import React, { useEffect, useState } from "react";
import { config } from "../core";

const DocIcon = () => 
  <svg
    className="tw-w-6 tw-h-6 tw-text-blue-500 tw-mr-3 tw-flex-shrink-0"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
;

function AppHelpHeader() {
  return (
    <header className="tw-sticky tw-top-0 tw-z-50 tw-bg-white tw-border-b tw-border-gray-200 tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center tw--mx-4 tw--mt-4 tw-mb-6">
      <div className="tw-flex tw-items-center">
        <img
          src="https://cdn.four-site.com/branding/foursite-arc-pro.svg"
          alt="Four Site"
          className="tw-h-6 tw-mr-3"
        />
        <span className="tw-font-semibold tw-text-gray-900">Help Center</span>
      </div>
    </header>
  );
}

function AppHelp() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`/static/${config.appVersion}/help/docs.json`)
      .then((res) => {
        if (!res.ok) {throw new Error("Help index not found");}
        return res.json();
      })
      .then((data) => {
        setCategories(data.categories || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const resolveUrl = (link) => {
    if (!link.slug && !link.url) {return "#";}
    const slug = link.slug || link.url.replace(/\.html?$/i, "");
    if (/^https?:\/\//i.test(slug)) {return slug;}
    return `/static/${config.appVersion}/help/${slug}.html`;
  };

  if (loading) {
    return (
      <div className="tw-p-4 tw-max-w-3xl tw-mx-auto">
        <AppHelpHeader />
        Loading help...
      </div>
    );
  }

  if (error) {
    return (
      <div className="tw-p-4 tw-max-w-3xl tw-mx-auto">
        <AppHelpHeader />
        <div className="tw-text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="tw-p-4 tw-max-w-3xl tw-mx-auto">
      <AppHelpHeader />
      <h1 className="tw-text-2xl tw-font-bold tw-mb-6">App Help</h1>

      {categories.length === 0 && 
        <p className="tw-text-gray-600">No help articles have been published yet.</p>
      }

      {categories.map((category, idx) => 
        <div key={idx} className="tw-mb-8">
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-700 tw-mb-3">
            {category.title}
          </h2>
          <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
            {(category.links || []).map((link, lidx) => {
              const href = resolveUrl(link);
              const isExternal = /^https?:\/\//i.test(href);
              const externalProps = isExternal
                ? { target: "_blank", rel: "noreferrer" }
                : {};
              return (
                <a
                  key={lidx}
                  href={href}
                  {...externalProps}
                  className="tw-block tw-bg-white tw-rounded-lg tw-shadow tw-p-4 hover:tw-shadow-md tw-transition"
                >
                  <div className="tw-flex tw-items-start">
                    <DocIcon />
                    <div>
                      <div className="tw-font-medium tw-text-gray-900">{link.title}</div>
                      {link.description && 
                        <div className="tw-text-sm tw-text-gray-500 tw-mt-1">{link.description}</div>
                      }
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default AppHelp;
